import { cn } from '@shared/lib/utils'

type TAsType = 'p' | 'span'

export interface ITextProps extends React.HTMLAttributes<HTMLParagraphElement> {
  as?: TAsType
}

export default function Text({ className, as: Comp = 'p', ...props }: ITextProps) {
  return <Comp className={cn('text-base font-normal leading-[1.3]', className)} {...props} />
}
